import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getEmployeesWithNoDept,
  checkNomDept,
  insertDept,
} from "../../../../services/RHService/DepartementService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddDepartment = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [employeeError, setEmployeeError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getEmployeesWithNoDept(getCurrentUserId());
        setEmployees(response.data?.success || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [formData, setFormData] = useState({});
  const handleInputChange = async (event) => {
    try {
      const target = event.target;
      const name = target.name;
      setFormData({ ...formData, [name]: target.value });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.nomDept || !formData.idEmployee) {
      toastr.error("Veuillez renseigner tous les champs.");
      return; // stop further execution if fields are missing
    }

    if (formData.idEmployee === "empl") {
      setEmployeeError("Veuillez saisir un chef de departement");
      return; // stop further execution if idEmployee is not valid
    } else {
      setEmployeeError("");
    }
    formData.idUser = getCurrentUserId();
    console.log(formData);

    const checkNomDeptExist = await checkNomDept(
      formData.nomDept,
      getCurrentUserId()
    );
    if (checkNomDeptExist >= 1) {
      toastr.error("Le nom de département existe déjà.");
      return; // stop further execution if department already exists
    }

    try {
      const response = await insertDept(formData);

      if (response.status === 200) {
        toastr.success(
          `La departement ${formData.nomDept} a été ajoutée avec succès.`
        );
      }
    } catch (error) {
      console.log(error.response?.data);
      toastr.error("Erreur lors de l'insertion.");
    }
  };

  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Ajouter Département</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/department_list">Liste des Départements</Link>
                </li>
                <li className="breadcrumb-item active">
                  Création d'une département
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid ">
          <div className="row ">
            <div className="col-md-12 ">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Ajouter une département</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card-body">
                        <div className="form-group">
                          <label>Nom de département</label>
                          <input
                            type="text"
                            name="nomDept"
                            value={formData.nomDept}
                            onChange={handleInputChange}
                            className="form-control form-control-border"
                            placeholder="Nom"
                          />
                        </div>

                        <div className="form-group">
                          <label>Chef de département </label>
                          <select
                            className="custom-select form-control-border"
                            name="idEmployee"
                            value={formData.idEmployee}
                            onChange={handleInputChange}
                          >
                            <option value="empl">
                              --Choisir un Chef de département--
                            </option>
                            {employees.map((employee) => (
                              <option
                                key={employee.idEmployee}
                                value={employee.idEmployee}
                              >
                                {employee.firstname} {employee.lastname}
                              </option>
                            ))}
                          </select>
                        </div>
                        {employeeError && (
                          <p style={{ color: "red" }}>{employeeError}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Confirmer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddDepartment;
